import React from 'react';
import ReactSelect from 'react-select';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';

import FormField from 'components/FormField';
import { customSelectStyles } from 'components/Select/styles';
import { FormMessageBoxStyled, FormMessageStyled } from 'components/ResqlExpert/formItemStyles';

export interface FormikSelectOption<T> {
  value: T;
  label: string;
}

interface Props<T> {
  name: string;
  label: string;
  placeholder: string;
  options: Array<FormikSelectOption<T>>;
  margin?: string;
  isDisabled?: boolean;
  isClearable?: boolean;
  isRequired?: boolean;
}

function FormikSelect<T>({
  name,
  label,
  placeholder,
  options,
  margin = '0',
  isDisabled = false,
  isClearable = false,
  isRequired  = false,
}: Props<T>) {
  const t =  usePrefix('ResqlExpert');
  const [field, , helpers] = useField<T | undefined>(name);

  return (
    <FormField label={label} margin={margin}>
      <ReactSelect
        options={options}
        value={options.find((o) => o.value === field.value) ?? null}
        onChange={(option) =>
          helpers.setValue((option as FormikSelectOption<T> | null)?.value ?? undefined)
        }
        onBlur={() => helpers.setTouched(true)}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={false}
        placeholder={placeholder}
        styles={customSelectStyles}
      />
      <FormMessageBoxStyled>
      {isRequired ? <FormMessageStyled>{t('field_required')}</FormMessageStyled> : null}
      </FormMessageBoxStyled>
    </FormField>
  );
}

export default FormikSelect;
